export default "__VITE_ASSET__5morDHkKMDwb5L3PNpMy3Q__"